import React from "react";
import { observer, inject } from "mobx-react";
import { observable, action } from "mobx";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { TwitterPicker } from "react-color";

import Editable from "./Editable";
// import {CAN_DELETE_LABEL, CAN_EDIT_LABEL} from "./authorization";

@injectIntl
@inject("rootStore")
@observer
export default class EditableLabel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.canEdit = props.rootStore.authorizationStore.canEditLabel;
    this.canDelete = props.rootStore.authorizationStore.canDeleteLabel;
  }

  @observable showColorPicker = false;

  render() {
    const { label, note, intl, rootStore } = this.props;

    if (!label || !note._isPersisted(label)) {
      return null;
    }

    const iconStyle = { color: label.color };

    return (
      <div
        className="note-editable-label-container"
        style={{ position: "relative" }}
      >
        <i
          className={`note-label-icon fa fa-tag`}
          style={iconStyle}
          aria-hidden="true"
          onClick={this.toggleColorPicker}
        />

        <Editable
          value={label.name}
          canEdit={this.canEdit}
          canDelete={this.canDelete}
          showDelete
          onEdit={value => note.editVPLabelName(label, value)}
          onDelete={() => note.deleteVPLabel(label)}
        />

        {/*<div className="note-label-color-picker-container">*/}

        {/*<div className="note-label-color-circle"*/}
        {/*onClick={this.triggerColorPicker}*/}
        {/*style={{background: label.color}}*/}
        {/*/>*/}
        {/*</div>*/}

        {this.showColorPicker && (
          <React.Fragment>
            <TwitterPicker onChange={this.handleColorChange} />
            <br />
          </React.Fragment>
        )}
      </div>
    );
  }

  @action
  toggleColorPicker = () => {
    const { note } = this.props;
    if (!this.canEdit) {
      return;
    }

    this.showColorPicker = !this.showColorPicker;
  };

  @action
  handleColorChange = (color, e) => {
    const { note, label } = this.props;

    note.editVPLabelColor(label, color.hex);
    this.toggleColorPicker();
  };
}

EditableLabel.propTypes = {
  label: PropTypes.object.isRequired,
  note: PropTypes.object.isRequired
};
